import { render, staticRenderFns } from "./SelectCRMSystemView.vue?vue&type=template&id=28ce8866&scoped=true"
import script from "./SelectCRMSystemView.vue?vue&type=script&lang=js"
export * from "./SelectCRMSystemView.vue?vue&type=script&lang=js"
import style0 from "./SelectCRMSystemView.vue?vue&type=style&index=0&id=28ce8866&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ce8866",
  null
  
)

export default component.exports